import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from 'features/core-firebase/auth.guard';
import { PublicGuard } from 'features/core-firebase/public.guard';


import { AppComponent } from './app.component';

import { PublicModule } from './public';
import { PrivateModule } from './private';

const routes: Routes = [
  {
    path: 'public',
    data: {
      animation: 'public',
    },
    // loadChildren: () => PublicModule,
     loadChildren: './public/public.module#PublicModule',
    //canActivate: [PublicGuard],
  },
  {
    path: 'private',
    data: {
      animation: 'private',
    },
    loadChildren: './private/private.module#PrivateModule',
    // loadChildren: () => PrivateModule,
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    redirectTo: 'private',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard],
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/Users/cmcever/Documents/GitHub/ChallengerTurf/EPSePortal/src/app/app-routing.module.ts